<template>
  <t-card>
    <div class="animate-pulse">
      <div class="bg-gray-300 h-52" />
      <div class="p-4">
        <div class="rounded bg-gray-300 h-3 w-1/2 my-1" />
        <div class="rounded bg-gray-300 h-10 my-1" />
        <div class="rounded bg-gray-300 h-4 my-1" />
        <div class="rounded bg-gray-300 h-5 w-3/4 my-1" />
      </div>
    </div>
  </t-card>
</template>

<script>
export default {
  name: 'ShadowCard',
};
</script>
